import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Switch, Route } from 'react-router-dom';
import { SovosGlobalLayout } from 's1-ui/sovos-global-layout';
import { AuthorizeComponent } from 'shared/helpers/authorizationHelper';
import OTPLogin from 'components/otpLogin/OTPLoginConnector';
import { routes, hiddenRoutes } from './Routes';
import 'components/app/app.css';
import unique from 'uniquid';
import goToS1 from 'shared/helpers/redirectionHelper';
import OrgCreationEditor from '../orgCreation/orgCreationEditor/OrgCreationEditorConnector';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPath: 'Dashboard',
      hash: unique(),
      allowedRoutes: this.checkAllowedRoutes()
    };
  }

  componentWillReceiveProps = nextProps => {
    if (this.props.selectedOrg !== nextProps.selectedOrg) {
      this.setState({ hash: unique() });
    }
    if (this.props.isFetchingPermissions && !nextProps.isFetchingPermissions) {
      this.setState({ allowedRoutes: this.checkAllowedRoutes() });
    }
  };

  selectNewOrg = newOrg => {
    delete newOrg['content'];
    delete newOrg['nestedItems'];
    this.props.contextsActions.setContext(newOrg);
  };

  checkAllowedRoutes = () => {
    const { checkPermissions } = this.props.manageUserActions;
    return routes
      .filter(route => checkPermissions(route.requiredPermissions))
      .map(route => {
        if (route.nestedRoutes) {
          return {
            ...route,
            nestedRoutes: route.nestedRoutes.filter(nestedRoute =>
              checkPermissions(nestedRoute.requiredPermissions)
            )
          };
        } else {
          return { ...route };
        }
      });
  };

  getNavProps = () => ({
    BrandingProps: { productName: 'USE TAX MANAGER' },
    initialSelectedLink: this.state.currentPath,
    selectedLink: this.state.currentPath,
    contexts: this.props.orgTree,
    selectedContext: this.props.selectedOrg || { name: '' },
    setContext: newOrg => this.selectNewOrg(newOrg),
    links: this.state.allowedRoutes.map(route => ({
      icon: route.icon,
      label: route.label,
      nestedLinks: !route.nestedRoutes
        ? []
        : route.nestedRoutes.map(nestedRoute => ({
          label: nestedRoute.label,
          action: () =>
            this.setState({ currentPath: nestedRoute.label }, () =>
              this.props.history.push(nestedRoute.path)
            )
        })),
      action: route.nestedRoutes
        ? () => {}
        : () => {
          this.setState({ currentPath: route.label }, () => {
            this.props.history.push({ pathname: `/${route.path}` });
          });
        }
    })),
    FooterProps: {
      userName: `${this.props.user.firstName} ${this.props.user.lastName}`,
      userMenuItems: [
        {
          label: 'Logout',
          action: () => {
            this.props.authActions.logout();
            goToS1();
          }
        }
      ]
    }
  });

  render() {
    const { selectedOrg, orgTree, userLogged } = this.props;
    const { hash, allowedRoutes } = this.state;
    return (
      <div>
        {userLogged && (
          <SovosGlobalLayout
            contexts={ orgTree }
            selectedContext={ selectedOrg }
            NavigationProps={ this.getNavProps() }
            width="100%"
          >
            <div className="sovos-global-layout-content">
              <Switch>
                {allowedRoutes.map(route => {
                  if (route.nestedRoutes) {
                    return route.nestedRoutes.map(nestedRoute => (
                      <Route
                        key={ nestedRoute.path }
                        path={ `/${nestedRoute.path}` }
                        render={ props =>
                          AuthorizeComponent(
                            <nestedRoute.component key={ hash } { ...props } />
                          )
                        }
                      />
                    ));
                  } else {
                    return (
                      <Route
                        key={ route.path }
                        path={ `/${route.path}` }
                        render={ props =>
                          AuthorizeComponent(
                            <route.component key={ hash } { ...props } />
                          )
                        }
                      />
                    );
                  }
                })}
                {hiddenRoutes.map(route => (
                  <Route
                    key={ route.path }
                    path={ `/${route.path}` }
                    render={ props =>
                      AuthorizeComponent(
                        <route.component key={ hash } { ...props } />
                      )
                    }
                  />
                ))}
                <Route path="/gtd-credentials" component={ OrgCreationEditor } />
              </Switch>
            </div>
          </SovosGlobalLayout>
        )}
        <Route exact path="/" component={ OTPLogin } />
      </div>
    );
  }
}

App.propTypes = {
  authActions: PropTypes.shape({
    logout: PropTypes.func
  }).isRequired,
  contextsActions: PropTypes.shape({
    setContext: PropTypes.func
  }).isRequired,
  manageUserActions: PropTypes.shape({
    checkPermissions: PropTypes.func
  }).isRequired,
  history: PropTypes.object.isRequired,
  selectedOrg: PropTypes.object.isRequired,
  orgTree: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
  userLogged: PropTypes.bool.isRequired,
  isFetchingPermissions: PropTypes.bool.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.js